import * as React from 'react';
import { registerComponent, withProgressiveHydration } from '@avensia/excite';
import { styled } from '@glitz/react';
import { createMinLargeViewportDecorator, createMaxSmallViewportDecorator } from 'webapp/viewport';
import CevoidContainer from 'webapp/components/cevoid-container';
import { Block, desktopEdgeMarginDecorator, maxContentNormalWidthDecorator } from 'webapp/components/page-layout';
import { headingDecorator } from 'webapp/decorators/heading';
import { isSvenssons } from 'webapp/theme';
import { useOnScreen } from '@avensia/excite-ui';

type PropType = NordicNest.Api.CevoidBlock & {
  centerHeader?: boolean;
};

export const CevoidBlock = styled(function CevoidBlock({
  title,
  galleryId,
  productId,
  dynamicallySetProductId,
  hidePrices,
  centerHeader = true,
}: PropType) {
  const [isInViewport, ref] = useOnScreen<HTMLDivElement>('400px');
  const [showCevoid, setShowCevoid] = React.useState();

  React.useEffect(() => {
    const shouldShow =
      galleryId.length > 0 &&
      window.CookieInformation &&
      window.CookieInformation?.getConsentGivenFor('cookie_cat_functional');

    setShowCevoid(shouldShow);
  }, [galleryId?.length]);

  const addStylesDecorator = styled(centerHeader && { textAlign: 'center' });
  return (
    <Base ref={ref}>
      {title && showCevoid && <Header css={addStylesDecorator}>{title}</Header>}
      {showCevoid && (
        <CevoidPlaceholder>
          {isInViewport && (
            <CevoidContainer
              galleryId={galleryId}
              productId={productId}
              dynamicallySetProductId={dynamicallySetProductId}
              hidePrices={hidePrices}
            />
          )}
        </CevoidPlaceholder>
      )}
    </Base>
  );
});

export const RegisteredCevoidBlock = registerComponent<NordicNest.Api.CevoidBlock>(
  withProgressiveHydration(CevoidBlock),
);

const Base = styled(
  Block,
  maxContentNormalWidthDecorator,
  desktopEdgeMarginDecorator,
  createMinLargeViewportDecorator({
    padding: {
      y: t => (isSvenssons ? t.spacing.m : t.spacing.xxl),
    },
  }),
  {
    padding: {
      top: t => (isSvenssons ? t.spacing.s : t.spacing.l),
    },
  },
);

const CevoidPlaceholder = styled.div(
  createMinLargeViewportDecorator({ minHeight: 278 }),
  createMaxSmallViewportDecorator({
    minHeight: 186,
  }),
  {
    minHeight: 235,
  },
);

const Header = styled.h2(headingDecorator, {
  fontSize: t => t.fontSize.l,
  marginBottom: t => t.sharedSpacing.l,
  fontWeight: t => t.fontWeight?.bold,
});
